// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__DvIqV","container-full":"styles_container-full__x27sm","textContent":"styles_textContent__o06Ui"};